export default {
    nav: {
        subject: "條款與政策"
    }
}
